<template>
  <BTableSimple
    v-bind="$attrs"
    :headers="headers"
    :actions="actions"
    class="BTablePublicationMunMeh"
    v-on="$listeners"
  />
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/Publications/MunMeh/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationMunMeh',
  components: {
    BTableSimple,
  },
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
